import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IArticleBannerCTA } from '@shared/db/IBanner';

import { BannerCtaImports } from './banner-cta.imports';
import { defaultBannerInfo } from './banners-data.db';

@Component({
  selector: 'noda-banner-cta',
  standalone: true,
  templateUrl: './banner-cta.component.html',
  styleUrls: ['./banner-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: BannerCtaImports,
})
export class BannerCtaComponent implements OnInit {
  public link: string;
  public foreignLink: string;
  @Input() public bannerInfo: IArticleBannerCTA;

  ngOnInit(): void {
    this.setDefaultBannerIfEmpty();
    this.setBtnLink();
  }

  private setBtnLink(): void {
    if (this.bannerInfo?.buttonUrl) {
      this.foreignLink = this.bannerInfo.buttonUrl;
    }

    this.setRouterLinkIfExists();
    this.setDefaultLinkIfEmpty();
  }

  private setDefaultBannerIfEmpty(): void {
    if (!this.bannerInfo) {
      this.bannerInfo = defaultBannerInfo;
    }
  }

  private setRouterLinkIfExists(): void {
    if (this.isInnerLink) {
      this.link = this.bannerInfo.buttonUrl;
      this.foreignLink = null;
    }
  }

  private get isInnerLink(): boolean {
    return this.bannerInfo.buttonUrl?.startsWith('/');
  }

  private setDefaultLinkIfEmpty(): void {
    const isSetDefaultLink: boolean = !this.foreignLink && !this.link;

    if (isSetDefaultLink) {
      this.link = defaultBannerInfo.buttonUrl;
    }
  }
}
